export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anfrage an den technischen Support"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["von"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nachricht hinzufügen"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dateien"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie können eine oder mehrere Dateien hochladen. Maximale Dateigröße - 10MB."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nachrichtentext"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])}
}